import React, { useEffect, useState, useMemo } from "react";
import {
    Delete as DeleteIcon,
    Edit as EditIcon,
    Add as AddIcon,
    TrendingUp,
} from "@material-ui/icons";
import DataTable from "../../../../../components/data-table";
import FormModalContent from "./form";
import ConfirmModalContent from "../../../../../components/confirm-modal-content";
import { useErrorHandler } from "../../../../../hooks";

import pageBuilderRowService from "../../../../../services/page-builder-row.service";
// import ChangeSort from "./changeSort";

const defaultKeys = [
    {
        title: "نام",
        field: "name",
        active: true,
    },
];

export default function PageRowContentModal(props) {

    const { page, data } = props

    const errorHandler = useErrorHandler();

    const [dataToShow, setDataToShow] = useState([])

    const deleteItem = async (item) => {
        console.log(data, item)
        await pageBuilderRowService.deletePageBuilderRowContent(data.id, item.index);
    };

    const headerCells = useMemo(
        () => [
            {
                field: "index",
                title: "ردیف",
                mainField: true,
            },
            {
                field: "title",
                title: "عنوان",
                mainField: true,
            },
            {
                field: "destinationURL",
                title: "مقصد",
                mainField: true,
            },
            {
                field: "image",
                title: "عکس",
                renderer: (val) =>
                    val ? <img className="main-page-img" src={val} alt="" /> : "-",
            },
        ],
        []
    );

    useEffect(() => {
        if(props.data.contents){
            setNewData(JSON.parse(props.data.contents))
        }
    }, [props.data.contents]);

    const setNewData = (data) => {
        setDataToShow(data.map((item, index) => ({...item, index})).sort((a, b) => a.index - b.index))
    }

    console.log(dataToShow)

    return (
        <div className="p-3">
            <DataTable
                headCells={headerCells}
                data={dataToShow}
                order={{order: "ASC", orderBy: "index"}}
                onRefresh={props.onRefresh}
                rowActions={[
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <EditIcon />,
                        modalContent: (props) => <FormModalContent {...props} parent={data} />,
                    },
                    // {
                    //     modalProps: { maxWidth: "sm" },
                    //     icon: <TrendingUp />,
                    //     hidden: (data) => data.type === "slider",
                    //     modalContent: (props) => <ChangeSort {...props} type={"slide"} allData={data}/>,
                    // },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <DeleteIcon />,
                        modalContent: (props) => (
                            <ConfirmModalContent
                                onConfirm={() => deleteItem(props.data)}
                                confirmText={props.data.name}
                                close={props.close}
                            />
                        ),
                    },
                ]}
                actions={[
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <AddIcon />,
                        tooltip: "ایجاد محتوا",
                        modalContent: (props) => <FormModalContent {...props} parent={data} />,
                    },
                ]}
                searchKeys={defaultKeys}
                title={`محتوای ردیف ${data.title} صفحه "${page.title}"`}
            />

        </div>
    );
}
